import cypressIds from 'Components/cypress_ids.json';
import { SpecSection } from 'Components/SpecSection';
import { useVehicleData } from 'Context/VehicleContext/VehicleDataContext';

import { isMobilizeVehicle } from '../ConditionAndDamageSection/helpers/isMobilizeVehicle';

import { WheelsAndTyresImages } from './WheelsAndTyresImages/WheelsAndTyresImages';
import {
	mobilizeWheelsAndTyresFields,
	TYRE_IMAGE_KIND,
	WHEEL_IMAGE_KIND,
	wheelsAndTyresFields,
} from './WheelsAndTyresSection.consts';

export const WheelsAndTyresSection: React.FC = () => {
	const { sourcePartner, wheelsAndTyres } = useVehicleData();
	const fields = isMobilizeVehicle(sourcePartner) ? mobilizeWheelsAndTyresFields : wheelsAndTyresFields;

	return (
		<>
			<SpecSection data={wheelsAndTyres} fields={fields} />
			<WheelsAndTyresImages cypressId={cypressIds.containers.wheels} kinds={WHEEL_IMAGE_KIND} title="Wheels" />
			<WheelsAndTyresImages cypressId={cypressIds.containers.tyres} kinds={TYRE_IMAGE_KIND} title="Tyres" />
		</>
	);
};
